import React from 'react';
import WipHomeLandingPage from './wip/WipHomeLandingPage.jsx';

const HomePage = () => {
  return <WipHomeLandingPage />;
};

export default HomePage;
